import { Loader } from "@software-engineering/hivolution-frontend-utils"
import { withAuth } from "oidc-react"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { authService } from "@/utils/auth/authService"
import { setAuthToken } from "@/utils/auth/authSlice"

const PrivateContent = ({ children, userData }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (userData?.access_token) {
      authService.setToken(userData.access_token)
      dispatch(setAuthToken(userData.access_token))
    }
  }, [userData?.access_token, dispatch])

  return userData && !userData.expired ? children : <Loader full />
}

export default withAuth(PrivateContent)
